<template>
  <div>
    <!-- 목록 (table4) -->
    <div class="scpm_table">
      <lego-paging-table
        ref="table"
        multiSelect
        selectAll
        tableFixed
        isNotScrollX
        v-model="selected"
        :items="valueTmp"
        :headers="recipientHeaders"
        :noDataText="t('page.eventStatus.noticeNoTarget')"
        :selectActionControl="false"
        :scrollMaxRow="maxRowTable"
        :noPage="true"
        @sort="onInnerTableSortChange"
      >
        <template #action>
          <lego-button primary @click="removeItem" :disabled="chkDeleteBtn" class="button-remove"
            >{{ t('button.remove') }}
          </lego-button>
          <!--삭제-->
        </template>
      </lego-paging-table>
    </div>
  </div>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import { EVENT_LEVELS } from '@/containers/utils/constant.js';
import { useAdditionalInfo } from '@/composables/addressBook/useAdditionalInfo.js';

const { getUserName } = useAdditionalInfo();

export default {
  mixins: [i18nMixin],
  emits: ['change-data', 'selectMethod', 'remove-item'],
  props: {
    maxRowTable: {
      type: Number,
      default: 7
    },
    valueTmp: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    userName: {
      type: String
    },
    isNotify: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      clickAction: this.selectMethod
    };
  },
  data() {
    return {
      notifData: [],
      selected: [],
      recipientHeaders: [
        {
          text: this.$t('page.eventStatus.notificationTargetGroup'),
          value: 'name',
          minWidth: 200,
          sortable: false,
          defaultValue: '-',
          customCell: this.nameCell()
        },
        {
          text: this.$t('page.eventStatus.eventRisk'), // 이벤트 위험도
          value: 'eventLevel',
          width: 120,
          sortable: false,
          customCell: () => {
            return this.$util.getEventLevel(this.eventLevelSet);
          }
        },
        {
          text: this.$t('page.eventStatus.notificationMethod'),
          value: 'sendMethod',
          width: 200,
          customCell: this.methodSelectedCell
        }
      ],
      notificationList: [],
      chkDeleteBtn: true
    };
  },
  computed: {
    eventLevelSet() {
      if (!this.rules || this.rules.length === 0) return [];
      let result = [];
      EVENT_LEVELS.forEach((eventLevel) => {
        let event = this.rules.find((item) => item.eventLevel == eventLevel);
        if (event) {
          result.push(eventLevel);
        }
      });

      return result;
    },
    totalCount() {
      return this.notifData.length;
    }
  },
  watch: {
    selected: {
      deep: true,
      handler() {
        this.chkDeleteBtn = this.selected.length <= 0;
      },
      immediate: true
    },
    valueTmp: {
      handler(nv) {
        this.notifData = [...nv];
        const recipientKeyValueTmp = this.selected.map((key) => key.recipientKey);
        this.selected = this.notifData.filter((item) =>
          recipientKeyValueTmp.includes(item.recipientKey)
        );
      },
      deep: true
    }
  },
  created() {
    this.notifData = [...this.valueTmp];
    this.notifData.forEach((item) => {
      const eventLevels = ['FATAL', 'WARNING', 'INFORM'];
      eventLevels.forEach((eventLevel) => {
        if (
          this.$util.isEmpty(item.notificationMethods.find((item) => item.eventLevel == eventLevel))
        ) {
          item.notificationMethods.push({ eventLevel: eventLevel, sendMethod: ['MAIL'] });
        }
      });
    });
    this.notificationList = this.$util.deepCopy(this.notifData);
    this.chkDeleteBtn = true;
    if (this.isNotify) {
      this.recipientHeaders.splice(1, 1);
    }
  },
  methods: {
    removeItem() {
      if (this.notifData.length > 0) {
        this.$modal.open({
          type: 'confirm',
          title: this.t('page.eventStatus.notice'),
          message: this.$t('page.eventStatus.deleteItem', [this.selected.length]),
          cancel: () => {
            //console.log('cancel');
          },
          action: () => {
            this.selected.forEach((item) => {
              const index = this.notifData.indexOf(item);
              this.notifData.splice(index, 1);
            });
            this.notificationList = this.$util.deepCopy(this.notifData);
            this.$emit('remove-item', {
              selected: this.selected,
              notificationList: this.notificationList
            });
            this.selected = [];
          }
        });
      }
    },
    nameCell() {
      return {
        props: {
          item: {
            type: Object,
            default: {}
          }
        },
        computed: {
          isUser() {
            return this.item.recipientType === 'USER';
          },
          content() {
            if (this.isUser) {
              return `${this.item.recipientName} (${
                this.item.userAdditionalInfo.email || this.item.userAdditionalInfo.userEmail || '-'
              }) / ${this.$t('page.eventStatus.defaultGroup')}`;
            }

            let userGroup = `${this.removeDoubleQuotation(this.item.recipientName)} (${getUserName(
              this.item
            )}`;

            if (this.item.addrbookAdditionalInfo.memberCount > 1) {
              userGroup += ` ${this.$t('label.otherOfPerson', [
                this.item.addrbookAdditionalInfo.memberCount - 1
              ])}`;
            }
            userGroup += ')';

            return userGroup;
          }
        },
        methods: {
          removeDoubleQuotation(value) {
            return value.replace(/["']/g, '');
          }
        },
        template: `
          <div v-if="isUser" class="ellipsis" v-lego-tooltip:ellipsis="content">{{ content }}</div>
          <div v-else style="display:flex; align-items: center;"><div class="ellipsis" v-lego-tooltip="$t('page.alarmGroup.alarmGroup')" style="margin-right: 3px; flex: 0 0 auto; width: 20px" v-html="$util.dangerIcon('G','G')"></div><div class="ellipsis" v-lego-tooltip:ellipsis="content">{{ content }}</div></div>
        `
      };
    },
    selectMethod(index, eventLevel, type) {
      this.$emit('change-data');
      let notificationMethod;

      if (this.isNotify) {
        notificationMethod = this.notifData[index].notificationMethods[0];
      } else {
        notificationMethod = this.notifData[index].notificationMethods.find(
          (item) => item.eventLevel == eventLevel
        );
      }

      if (notificationMethod != null && notificationMethod.sendMethod != null) {
        if (notificationMethod.sendMethod.includes(type)) {
          let i = notificationMethod.sendMethod.indexOf(type);
          notificationMethod.sendMethod.splice(i, 1);
        } else {
          notificationMethod.sendMethod.push(type);
        }
      }

      this.notificationList = this.$util.deepCopy(this.notifData);
      this.$emit('selectMethod', this.notificationList);
      this.$refs.table.$forceUpdate();
    },
    generateMethodSelect(index, item, eventRisk) {
      return `<ScpmMethodSelect :seq="'${
        item.seq
      }'" :index="${index}" eventLevel="${eventRisk}" :sendMethod="'${this.getSendMethod(
        item,
        eventRisk
      )}'" :readonly="${this.readonly}"/>`;
    },
    methodSelectedCell(value, index, item) {
      let result = `<div style="margin-top:5px;line-height:29px">`;
      if (this.isNotify) {
        result += `<ScpmMethodSelect :seq="'${
          item.seq
        }'" :index="${index}" :eventLevel="''" :sendMethod="'${this.getSendMethod(item)}'" />`;
      } else {
        EVENT_LEVELS.forEach((level) => {
          if (this.eventLevelSet.includes(level))
            result += this.generateMethodSelect(index, item, level);
        });
      }

      result += `</div>`;
      return result;
    },
    getSendMethod(item, eventLevel) {
      let notification = item.notificationMethods.find((item) => item.eventLevel == eventLevel);
      if (!eventLevel) {
        return item.notificationMethods[0].sendMethod;
      }
      if (this.$util.isEmpty(notification)) {
        item.notificationMethods.push({ eventLevel: eventLevel, sendMethod: ['MAIL'] });
        return ['MAIL'];
      } else {
        return notification.sendMethod;
      }
    },
    onInnerTableSortChange(header) {
      const expanded = this.notifData;
      const order = header.asc ? 'asc' : 'desc';
      if (expanded) {
        let field = '';
        switch (header.text) {
          case this.$t('page.eventStatus.notificationTargetGroup'): //'알림대상자 / 그룹'
            field = 'recipientName';
            break;
          default:
            break;
        }
        if (field) {
          this.notifData = this.$util.customSort(expanded, field, order);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.subtitle {
  padding: 10px 0 0 0;
  margin-bottom: 12px;
}

.table-header-wrap {
  padding-bottom: 10px;

  &:after {
    content: '';
    clear: both;
    display: table;
  }

  & .left-con {
    float: left;
    width: 40%;
  }

  & .right-con {
    float: right;
    width: 60%;
    text-align: right;
  }
}

:deep .lego-table .lego-table__control {
  flex: none !important;
}
</style>
